import React, { useState } from 'react'
import { Query } from 'react-apollo'
import moment from 'moment'
import { useQuery, useMutation } from '@apollo/react-hooks'
import {
  Col, Input as Ip, Modal, Select, message,
} from 'antd'
import _ from 'lodash'
import InfiniteScroll from 'react-infinite-scroller'
import {
  Div, H3, Button, Loading, DynamicButtonLink, P, H4, H5,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { TRUCK_TIRE_USAGE_LOG_LIST } from '../../../constants/graph/query'
import '../list/style-css.css'
import { Wrapper } from '../../../components/truck-components'
import { TRUCK_INFO } from '../../../constants/graphql/query'
import history from '../../../history'

const { color } = theme

const calculateTime = (startTime, endTime) => {
  let timeTh = ''
  let properEndTime = endTime
  let properStartTime = startTime
  if (endTime == null) properEndTime = moment()
  if (moment(properEndTime).diff(properStartTime, 'years') > 0) {
    timeTh += moment(properEndTime).diff(properStartTime, 'years')
    timeTh += ' ปี '
    properStartTime = moment(properStartTime).add(moment(properEndTime).diff(properStartTime, 'years'), 'years')
  }
  if (moment(properEndTime).diff(properStartTime, 'months') > 0) {
    timeTh += moment(properEndTime).diff(properStartTime, 'months')
    timeTh += ' เดือน '
    properStartTime = moment(properStartTime).add(moment(properEndTime).diff(properStartTime, 'months'), 'months')
  }
  timeTh += moment(properEndTime).diff(properStartTime, 'days')
  timeTh += ' วัน '
  return timeTh
}

export default ({ props }) => {
  const {
    data, loading, error, refetch,
  } = useQuery(TRUCK_TIRE_USAGE_LOG_LIST, { variables: { truckId: parseInt(props.match.params.id, 10) } })
  if (loading && _.isEmpty(data)) return <Loading center='true' />
  if (error) return <p>เกิดข้อผิดพลาด</p>
  if (data.TireUsedLogListForTruck.lists.length === 0) return <H3 bold color={color.primaryColor} margin='32px 0'>ไม่มีประวัติการเปลี่ยนยางของรถบรรทุกนี้</H3>
  return (
    <Div display='flex' flexDirection='column'>
      <Wrapper overflow padding='0 0 40px 0' flex>
        <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' padding='0'>
          <H3 bold color={color.primaryColor} margin='32px 0'>ประวัติการเปลี่ยนยาง</H3>
        </Div>
        <Div display='flex' flexDirection='row' justifyContent='flex-start' alignItems='center' padding='0'>
          <Col md={{ span: 4 }}>
            <Div display='flex' justifyContent='center' margin='8px 0 24px'>
              <P bold>ทะเบียนหัว</P>
            </Div>
            <Div display='flex' justifyContent='center' margin='8px 0 16px'>
              <P>{data.TireUsedLogListForTruck.lists[0].Service.job.Truck.plateNumber}</P>
            </Div>
          </Col>
          <Col md={{ span: 4 }}>
            <Div display='flex' justifyContent='center' margin='8px 0 24px'>
              <P bold>ชนิดรถ</P>
            </Div>
            <Div display='flex' justifyContent='center' margin='8px 0 16px'>
              <P>{data.TireUsedLogListForTruck.lists[0].Service.job.Truck.type ? data.TireUsedLogListForTruck.lists[0].Service.job.Truck.type.nameTh : 'ไม่มีข้อมูล'}</P>
            </Div>
          </Col>
          <Col md={{ span: 4 }}>
            <Div display='flex' justifyContent='center' margin='8px 0 24px'>
              <P bold>เลขคัสซี</P>
            </Div>
            <Div display='flex' justifyContent='center' margin='8px 0 16px'>
              <P>{data.TireUsedLogListForTruck.lists[0].Service.job.Truck.chassisNumber ? data.TireUsedLogListForTruck.lists[0].Service.job.Truck.chassisNumber : 'ไม่มีข้อมูล'}</P>
            </Div>
          </Col>
        </Div>
      </Wrapper>
      <Div>
        <Wrapper overflow padding='40px 0 40px 0' flex>
          <Div display='flex' flexDirection='row' margin='8px 0 24px'>
            <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>วันที่เริ่มใช้</P></Div></Col>
            <Col md={{ span: 1 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ล้อที่</P></Div></Col>
            <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>เบอร์ยาง</P></Div></Col>
            <Col md={{ span: 3 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ชื่อยาง</P></Div></Col>
            <Col md={{ span: 3 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ประเภทยาง</P></Div></Col>
            <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>เลขที่ใบแจ้งซ่อม</P></Div></Col>
            <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ไมล์เข้า</P></Div></Col>
            <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ไมล์ออก</P></Div></Col>
            <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ระยะทาง</P></Div></Col>
            <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>วันที่ตีออก</P></Div></Col>
            <Col md={{ span: 3 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>อายุการใช้งาน</P></Div></Col>
          </Div>
          {
            _.map(data.TireUsedLogListForTruck.lists, v => <Div display='flex' flexDirection='row' margin='8px 0 16px'>
              <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.inDate ? moment(v.inDate).format('DD-MM-YYYY') : 'ไม่มีข้อมูล'}</P></Div></Col>
              <Col md={{ span: 1 }}><Div display='flex' justifyContent='center'><P>{v.wheelNo || 'ไม่มีข้อมูล'}</P></Div></Col>
              <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.Serial.serialNumber}</P></Div></Col>
              <Col md={{ span: 3 }}><Div display='flex' justifyContent='center'><P>{v.Serial.inventoryOption.variantName}</P></Div></Col>
              <Col md={{ span: 3 }}><Div display='flex' justifyContent='center'><P>{v.Serial.Tire && v.Serial.Tire.TireType ? v.Serial.Tire.TireType.name : 'ไม่มีข้อมูล'}</P></Div></Col>
              <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.Service.job.id}</P></Div></Col>
              <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.startMileAge}</P></Div></Col>
              <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.endMileAge}</P></Div></Col>
              <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.distance}</P></Div></Col>
              <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.outDate ? moment(v.outDate).format('DD-MM-YYYY') : 'ไม่มีข้อมูล'}</P></Div></Col>
              <Col md={{ span: 3 }}><Div display='flex' justifyContent='center'><P>{v.inDate ? calculateTime(v.inDate, v.outDate) : 'ไม่มีข้อมูล'}</P></Div></Col>
            </Div>)
          }
        </Wrapper>
      </Div>
    </Div>
  )
}
